
import React      from 'react';
import CSSModules from 'react-css-modules';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import ModuleForm       from '../ModuleForm';
import YesNoOptionPanel from '../YesNoOptionPanel';

import * as moduleList from '../../actions/moduleList';

import { connect } from 'react-redux';

import style from './style.scss';

class AdminModulePage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uniqueId: null,
            pageReloaded: false
        }
    }

    componentDidMount() {
        this.props.loadAllModules();
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.isOverlayVisible && this.state.pageReloaded) {
            this._generateRandomId();
            this.setState({pageReloaded: false})
        }
        if(nextProps.isOverlayVisible) {
            this.setState({pageReloaded: true})
        }
    }

    _generateRandomId() {
        this.setState({ uniqueId: Date.now() });
    }

    _getOverlayTitle() {

        switch (this.props.overlayMode) {

            case 'add':
                return 'Add Category';

            case 'edit':
                return 'Edit Category';
        }
    }

    _getDeleteOverlayContent() {

        const { moduleToDelete } = this.props;

        return (
            <div>

                <p>
                    Are you sure you want to to delete the&nbsp;

                    <span styleName="module-name--to-delete">
                        { moduleToDelete.name }
                    </span>

                    &nbsp;module and all of its associated courses and events?
                </p>

                <YesNoOptionPanel
                    no={ this.props.hideDeleteOverlay }
                    yes={ this.props.deleteModule.bind(this, moduleToDelete) } />

            </div>
        );
    }

    _getModuleBackgroundStyle(module) {

        if(module.background_image){
            return {

                backgroundImage: `url('/api/v1/modules/${module.id}/image?no-cache=${this.state.uniqueId}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
            };
        } else {
            return {
                backgroundColor: module.hex_colour
            };
        }

    }

    _getModuleTitleStyle(module) {

        if(module.background_image) {
            let color = module.hex_colour;
            return {
                color: color
            };
        } else {
            return {};
        }
    }

    render() {

        return (

            <article>

                <Button onClick={ this.props.showNewModuleOverlay }
                        className={ style['new-module-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New Category</span>

                </Button>

                <Overlay isOpen={ this.props.isOverlayVisible }
                         closeOverlay={ this.props.hideNewModuleOverlay }
                         title={ this._getOverlayTitle() }
                         size="small">

                    <ModuleForm
                        moduleToEdit={this.props.moduleToEdit}
                    />

                </Overlay>

                <Overlay isOpen={ this.props.isDeleteOverlayVisible }
                         closeOverlay={ this.props.hideDeleteOverlay }
                         title="Delete Module"
                         size="small">

                    { this.props.isDeleteOverlayVisible && this._getDeleteOverlayContent() }

                </Overlay>

                <section className={style['module-container']}>

                    {
                        this.props.modules.map((module, index) => {

                            let moduleBackgroundStyle = this._getModuleBackgroundStyle(module);
                            let moduleTitleStyle = this._getModuleTitleStyle(module);

                            return (
                                <article key={ index } styleName="module" style={ moduleBackgroundStyle }>

                                    <h2 className={style['module-title']} style={ moduleTitleStyle }>
                                        { module.name }
                                    </h2>

                                    <div className={style['module-actions-panel']}>

                                        <a href="javascript:void(0)"
                                           onClick={ this.props.showEditOverlay.bind(this, module) }
                                           className={style['edit-module']}>

                                            Edit
                                        </a>

                                        <a href="javascript:void(0)"
                                           onClick={ this.props.showDeleteOverlay.bind(this, module) }
                                           className={style['delete-module']}>

                                            Delete
                                        </a>

                                    </div>
                                </article>
                            )
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.moduleList;
}

function mapDispatchToProps(dispatch) {

    return {
        showNewModuleOverlay: () => {

            dispatch(moduleList.setModuleOverlayMode('add'));
            dispatch(moduleList.setModuleOverlayVisibility(true));
        },
        hideNewModuleOverlay: () => {
            dispatch(moduleList.setModuleOverlayVisibility(false));
        },
        loadAllModules: () => {

            dispatch(moduleList.refreshModules());
        },
        showEditOverlay: (module) => {

            dispatch(moduleList.setModuleOverlayMode('edit'));
            dispatch(moduleList.setModuleToEdit(module));
            dispatch(moduleList.setModuleOverlayVisibility(true));
        },
        showDeleteOverlay: (module) => {

            dispatch(moduleList.showDeleteOverlay(module));
        },
        hideDeleteOverlay: () => {

            dispatch(moduleList.hideDeleteOverlay());
        },
        deleteModule: (module) => {

            dispatch(moduleList.deleteModule(module));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(AdminModulePage, style));


// WEBPACK FOOTER //
// ./components/AdminModulePage/index.js